import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import { Calendar } from 'primereact/calendar';
import { Typography } from '../Typography';
import { InfoTooltip } from '../Tooltip/InfoTooltip';

interface FormDateProps extends FieldProps<Date, FieldRenderProps<Date>> {
  id?: string;
  label?: string;
  placeholder?: string;
  tooltip?: React.ReactNode;
  initialValue?: Date;
  required?: boolean;
}

export const FormDateYear: React.FC<FormDateProps> = props => {
  const currentYear = new Date().getFullYear();

  const defaultDate = useMemo(() => props.initialValue || new Date(), [props.initialValue]);

  return (
    <Field<Date>
      type="date"
      {...props}
      initialValue={defaultDate}
      render={({ input }) => (
        <Container id={props.id}>
          <Label>
            <Typography variant="body6">
              <label htmlFor={props.name}>
                {props.label} {props.required && <span style={{ color: '#6777FF' }}>*</span>}
              </label>
            </Typography>
            {props.tooltip && (
              <InfoTooltip
                name={`date-tooltip-${props.name}`}
                tooltip={props.tooltip}
              />
            )}
          </Label>

          <StyledCalendar
            {...input}
            value={input.value || defaultDate}
            onChange={e => input.onChange(e.value)}
            showIcon
            placeholder={props.placeholder}
            view="year"
            dateFormat="yy"
            maxDate={new Date(currentYear, 11, 31)}
          />
        </Container>
      )}
    />
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledCalendar = styled(Calendar)`
  border-radius: 10px;

  .p-datepicker-trigger {
    background-color: ${({ theme }) => theme.palette.button.primary};
  }
`;

const Label = styled.div`
  display: flex;
  gap: 4px;
`;
